<template>
  <div>
    <v-row >
      <v-col sm="3" md="3"></v-col>
      <v-col  sm="6" md="6">
        <v-autocomplete
          :items="inst_list"
          v-model="inst_data"
          item-text="name"
          label="Search Employee"
          dense
          return-object
            filled
            outlined
             :loading="comp_load"
             placeholder="Search by employee code or name"
             @change="getData"
        ></v-autocomplete>
      </v-col>
       <v-col sm="3" md="3"></v-col>
    </v-row>
      <employee-profile-tab v-if="inst_data!=null" :instid="inst_data.instid"></employee-profile-tab>
  </div>
</template>
<script>
import axios from "axios";
import EmployeeProfileTabs from './EmployeeProfileTabs'
export default {
    components:{
      'employee-profile-tab':EmployeeProfileTabs,
    },
  data: () => ({
    comp_load: false,
    inst_list: null,
    inst_data:null,
  }),
  mounted() {
    this.comp_load = true;
    this.inst_data = null;
    axios
      .post("/RoleManagement/getAllEmployee")
      .then(res => {
        if (res.data.msg == "200") {
          this.inst_list = res.data.inst_list;
        } else {
          alert("Somthing went wrong!!!");
        }
      })
      .catch(error => {
        alert("Somthing went wrong!!!");
      })
      .finally(() => {
        this.comp_load = false;
      });
  },
  methods: {
   getData(){

   }
  }
};
</script>

